import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-text-with-cover-image',
  templateUrl: './text-with-cover-image.component.html',
  styleUrls: ['./text-with-cover-image.component.css'],
})
export class TextWithCoverImageComponent{
  @Input() data!:any;
  
}
